module.exports = __webpack_public_path__ + "static/media/1900060.1e322988.geojson";


//////////////////
// WEBPACK FOOTER
// ./src/elections/us/GeoData/1900060.geojson
// module id = 413
// module chunks = 0